import axiosInstance from "./api_helper";

const invoiceSupplierService = {
    search: async ({ search = '', page = 0, size = 10 }) => {
        const response = await axiosInstance.get('/api/factures-fournisseur', {
            params: { search, page, size }
        });
        return response.data;
    },

    searchPayments: async (query) => {
        return axiosInstance.post(`/api/supplier/payments/search`, JSON.stringify(query));
    },
    searchInvoiceSummary: async (query) => {
        return axiosInstance.post(`/api/suppliers/invoice-summaries`, JSON.stringify(query));
    },   

    getNewInvoiceNumber: async (type) => {
        return await axiosInstance.get(`/api/supplier/invoices/new-invoice-number/${type}`);
    },

    addInvoice: async (invoiceData) => {
        return await axiosInstance.post('/api/factures-fournisseur/generate-consolidated', invoiceData);
    },

    addPayment: async (paymentData) => {
        return await axiosInstance.post('/api/supplier/payments', paymentData);
    },

    generateDocument: async (id) => {
        const response = await axiosInstance.get(`/api/supplier/invoices/report/${id}`, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    generateReleve: async (query) => {
        const response = await axiosInstance.post(`/api/supplier/invoices/releve`, JSON.stringify(query), {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    deleteInvoice: async (invoiceId) => {
        const response = await axiosInstance.delete(`/api/supplier/invoices/${invoiceId}`);
        return response.data;
    },

    filterInvoice: async (query) => {
        return axiosInstance.post(`/api/supplier/invoices/search`, JSON.stringify(query));
    },

    getLastSavedInvoice: async () => {
        return await axiosInstance.get(`/api/supplier/invoices/last-saved`);
    },

    updateInvoice: async (invoiceId, invoiceData) => {
        return await axiosInstance.put(`/api/factures-fournisseur/${invoiceId}`, JSON.stringify(invoiceData));
    },

}

export default invoiceSupplierService;